export enum CollectTransactionStatusType {
  Executed = 'Executed',
  Failed = 'Failed',
  Initiated = 'Initiated',
  Processing = 'Processing',
}
